import { z } from "zod";
import { Address, ContactPerson, StringNE } from "./common.schema.js";

export const SavePurchaserDiscount = z.object({
  nominatedPurchaserId: z.string(),
  purchaserDiscount: z.string().nullable(),
});
export type SavePurchaserDiscount = z.infer<typeof SavePurchaserDiscount>;

export const UpdateSavedDeliveryInfo = z.object({
  deliveryPointName: StringNE,
  address: Address,
  contact: ContactPerson.nullable(),
  instruction: StringNE.nullable(),
  bonded: z.boolean(),
});
export type UpdateSavedDeliveryInfo = z.infer<typeof UpdateSavedDeliveryInfo>;
